module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pos/invoices/invoices-show/invoices-show.component.scss
// module id = ./src/app/views/pos/invoices/invoices-show/invoices-show.component.scss
// module chunks = main